var map = {
	"./back.svg": "yQ1v",
	"./back_icon_merch.svg": "QVKs",
	"./close.svg": "5XYE",
	"./icon-ARTIST.svg": "g/+P",
	"./icon-EVENTS.svg": "Tm7Z",
	"./icon-POPULAR_SEARCHES.svg": "MgWj",
	"./icon-TEAM.svg": "4EAs",
	"./icon-VENUES.svg": "F9iK",
	"./load.svg": "Zmmn",
	"./search.svg": "TJFD",
	"./search_icon_merch.svg": "KqGn",
	"./search_modal.svg": "Xz2K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dgW/";